import { PHPContext } from "../../../../library-js/php/PHPContext";
import { Cookies } from "../../../../library-js/php/cookie-info/Cookies";
import { PHPResponse } from "../../../../library-js/php/PHPResponse";
import { QuickJSON } from "../../../../library-js/text/QuickJSON";
import { Objects } from "../../vanilla/serialization/Objects";
import { RJLog } from "../../node/log/RJLog";

export class CookieSettings
{
  protected static _phpContext:PHPContext;
  protected static _names:Map<CookieSettings,string> = new Map<CookieSettings,string>(); 

  static _setContext( phpContext:PHPContext )
  {
    this._phpContext = phpContext;
  }

  static setName( cookieSettings:CookieSettings, name:string )  
  {
    CookieSettings._names.set( cookieSettings, name );
  }

  static create( name:string )
  {
    let cs = new CookieSettings();
    CookieSettings._names.set( cs, name );
    return cs;
  }

  static async save( cs:CookieSettings ):Promise<PHPResponse>
  {
    let name = CookieSettings._names.get( cs );
    let response = await Cookies.set( CookieSettings._phpContext, name, JSON.stringify( cs ) );

    return Promise.resolve( response );
  }

  static async load( cs:CookieSettings ):Promise<boolean>
  {
    let name = CookieSettings._names.get( cs );
    let response = await Cookies.get( CookieSettings._phpContext, name );

    if ( response.error )
    {
      return Promise.resolve( false );
    }

    let value = JSON.parse( response.value );

    Objects.copyTo( value, cs );

    return Promise.resolve( true );
  }
}